import Component from '@glimmer/component';

import { array, hash } from '@ember/helper';
import { cached } from '@glimmer/tracking';
import { Menu } from 'ember-primitives';

import DropdownListButtonButton from 'rise-ui/components/dropdown-list-button/button.gjs';
import DropdownListButtonHeading from 'rise-ui/components/dropdown-list-button/heading.gjs';
import DropdownListButtonItem from 'rise-ui/components/dropdown-list-button/item.gjs';
import DropdownListButtonLink from 'rise-ui/components/dropdown-list-button/link.gjs';
import { classMix } from 'rise-ui/decorators/class-mix';
import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import hasEndSuffix from 'rise-ui/helpers/has-end-suffix.js';

export default class DropdownListButtonComponent extends Component {
  /** @type {ClassMix} */
  @classMix classMixed;

  @cached get classModCfg() {
    return this.classMixed.mixClassModConfig(
      'c-dropdown-list-button',
      this.args.disabled, '--disabled',
    );
  }

  get side() {
    return this.args.side || 'bottom-start';
  }

  <template>
    <Menu @offsetOptions={{8}}
      @placement={{this.side}}
      as | menu |
    >
      <DropdownListButtonButton
        @classMix={{classMod config=this.classModCfg}}
        @type={{@type}}
        @disabled={{@disabled}}
        @title={{@title}}
        {{menu.trigger}}
        ...attributes
        as | btn |
      >
        {{yield (hash button=btn)}}
      </DropdownListButtonButton>
      <menu.Content
        data-layer={{@layer}}
        class={{concatClasses
          "floatybit"
          "qa-ddlb"
          (classMod config=this.classModCfg suffix="__dropdown")
          (classMod
            config=this.classModCfg
            suffix="__popover"
            modifiers=(array (hasEndSuffix this.side) "--end")
          )
        }}
      >
        {{yield (hash
          heading=(component DropdownListButtonHeading
            mixClass=(classMod config=this.classModCfg suffix="__heading")
          )
          item=(component DropdownListButtonItem
            mixClass=(classMod config=this.classModCfg suffix="__item")
          )
          link=(component DropdownListButtonLink
            mixClass=(classMod config=this.classModCfg suffix="__item")
          )
        )}}
        <div class={{classMod config=this.classModCfg suffix="__popover-arrow"}}
          {{menu.arrow}}
        />
      </menu.Content>
    </Menu>
  </template>
}
